export default "__VITE_ASSET__be11c250__"